<template>
  <v-navigation-drawer
    :value="open"
    :permanent="$vuetify.breakpoint.lgAndUp"
    :mini-variant="isMini"
    app
    :width="drawerWidth"
    class="py-4"
    :color="$vuetify.theme.dark ? 'grey darken-4' : 'white'"
    @input="$emit('drawerChange', $event)"
  >
    <v-img
      class="mx-auto"
      :width="isMini ? '36px' : '185px'"
      src="/assets/ekpa-logo-text-transparent.png"
      :style="{
        filter: $vuetify.theme.dark ? 'invert(0.85) brightness(0.9)' : 'none'
      }"
    />

    <v-divider class="my-6" />

    <v-tabs
      vertical
      :background-color="$vuetify.theme.dark ? 'transparent' : 'transparent'"
    >
      <v-tooltip v-for="tab in tabs" :key="tab.to" right :disabled="!isMini">
        <template #activator="{ on }">
          <v-tab
            :to="tab.to"
            class="justify-start ml-0 nav-tab"
            :class="{ 'nav-tab--mini': isMini }"
            v-on="on"
          >
            <v-icon :class="{ 'mr-4': !isMini }">
              {{ tab.icon }}
            </v-icon>

            <span
              v-if="!isMini"
              class="text-body-1 font-weight-medium text-capitalize"
            >
              {{ tab.text }}
            </span>
          </v-tab>
        </template>

        <span>{{ tab.text }}</span>
      </v-tooltip>
    </v-tabs>

    <div
      class="resize-handle"
      :class="{ 'resize-handle--active': isResizing }"
      @mousedown.prevent="startResize"
    />
  </v-navigation-drawer>
</template>

<script>
const MIN_WIDTH = 56
const MAX_WIDTH = 520
const MINI_THRESHOLD = 150

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawerWidth: 280,
      isResizing: false,
      tabs: [
        {
          to: '/requests',
          text: 'Αιτήσεις',
          icon: 'mdi-clipboard-text-outline'
        },
        {
          to: '/devices',
          text: 'Τηλεφωνικές συσκευές',
          icon: 'mdi-deskphone'
        },
        {
          to: '/number-pools',
          text: 'Αριθμοδοτικοί πόροι',
          icon: 'mdi-sim-outline'
        },
        {
          to: '/cucm-groups',
          text: 'Ευκολίες',
          icon: 'mdi-list-box-outline'
        },
        {
          to: '/warehouse',
          text: 'Αποθήκες',
          icon: 'mdi-warehouse'
        },
        {
          to: '/models',
          text: 'Μοντέλα',
          icon: 'mdi-phone-log'
        }
      ]
    }
  },
  computed: {
    isMini() {
      return this.drawerWidth < MINI_THRESHOLD
    }
  },
  methods: {
    startResize(e) {
      this.isResizing = true
      document.addEventListener('mousemove', this.onResize)
      document.addEventListener('mouseup', this.stopResize)
    },
    onResize(e) {
      const newWidth = e.clientX
      if (newWidth >= MIN_WIDTH && newWidth <= MAX_WIDTH) {
        this.drawerWidth = newWidth
      }
    },
    stopResize() {
      this.isResizing = false
      document.removeEventListener('mousemove', this.onResize)
      document.removeEventListener('mouseup', this.stopResize)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-tab {
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  &--mini {
    justify-content: center !important;
    padding: 0 !important;
    min-width: 0 !important;
  }
}

.theme--dark .nav-tab:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  cursor: ew-resize;
  transition: background-color 0.15s ease;

  &:hover,
  &--active {
    background-color: var(--v-primary-base);
    opacity: 0.4;
  }
}
</style>
